import { LayerModule } from './.LayerModule';
import ApiLayersMap from '../WebApiModules/ApiLayersMap.js';

export class LayerI3SModule extends LayerModule {
    async OpenLayer(callback) {
        return new Promise((rs) => {
            ApiLayersMap.ListLayerInfo(
                { FolderFullName: this.layerInfo.FolderFullName, Name: this.layerInfo.Name },
                (obj) => {
                    console.log(obj);
                    let result = obj.result;
                    window.gMainMap.TerrainView.addOGCI3SLayer({
                        url: result.URL,
                        urlTemplate: result.URLTemplate || window.gMainMap.ProxyUrlTemplete(),
                        identifier: result.ID,
                        callback: (success, layer) => {
                            rs({ success, layer })
                        },
                    });
                },
                () => {
                    console.error(`取得${this.layerInfo.FolderFullName}/${this.layerInfo.Name}圖層資訊失敗`)
                }
            )
        }).then((param) => {
            console.log(param);
            // 有參考的圖層到都加進去
            this.oviewLayer = param.layer;
            window.gMainMap.TerrainView.openedLayerStack.push(this.oviewLayer.name);

            callback && callback(param);
            return param.success;
        }, () => {
            return false;
        });
    }
}